import { SharedSpinner } from '@components';
import { useInspectionTenantCategories } from '@hooks';
import { InspectionCategory } from '@services';
import { Select } from 'antd';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

interface IProps {
  allowClear?: boolean;
  selectedInspections: InspectionCategory[];
  setSelectedInspections: (inspection: InspectionCategory[]) => void;
  handleSelect?: (id: number) => void;
  handleDeselect?: (id: number) => void;
}

export const InspectionTenantCategorySelect: React.FC<IProps> = observer(
  ({ allowClear, selectedInspections, setSelectedInspections, handleSelect, handleDeselect }) => {
    const { dataSource, loading } = useInspectionTenantCategories();

    const options = useMemo(() => {
      return dataSource.map((category) => ({
        label: category.name,
        value: category.id,
      }));
    }, [dataSource]);

    const onSelect = (id: number) => {
      const selectedInspection = dataSource.find((category) => category.id === id);

      if (!selectedInspection) return;

      setSelectedInspections([...selectedInspections, selectedInspection]);

      handleSelect && handleSelect(id);

      return;
    };

    const onDeselect = (id: number) => {
      setSelectedInspections(selectedInspections.filter((x) => x.id !== id));

      handleDeselect && handleDeselect(id);
    };

    const onClear = () => {
      setSelectedInspections([]);
    };

    return (
      <Select
        allowClear={allowClear}
        mode="multiple"
        loading={loading}
        notFoundContent={null}
        filterOption={false}
        style={{ width: '100%' }}
        value={selectedInspections.map((x) => x.id)}
        options={options}
        onClear={onClear}
        onSelect={onSelect}
        onDeselect={onDeselect}
        placeholder={'Select inspection'}
        dropdownRender={(menu) => (
          <div>
            {menu}
            {loading && (
              <div style={{ textAlign: 'center', padding: '8px 0' }}>
                <SharedSpinner loading={loading} />
              </div>
            )}
          </div>
        )}
      />
    );
  }
);
